import React from "react";
import { DialogTitle, DialogContent, DialogActions, Button, Stack, Tooltip, IconButton, TextField, Menu } from "@mui/material";
import { D, C } from "../include";
import { Stage, Layer, Text, Line, Image } from 'react-konva';
import { DriveFileRenameOutline, CleaningServices, Undo, Abc, Photo, ImageNotSupported } from '@mui/icons-material';
import { HexColorPicker } from "react-colorful";

export class PlanningDialog extends React.Component {
  constructor(props) {
    super(props);    
    this.state = {
      session_id: this.props.session_id ? this.props.session_id : -1,
      read_only: this.props.read_only ? this.props.read_only : false,
      background_image_id: this.props.background_image_id ? this.props.background_image_id : -1,
      background_image_from_url : "",
      background_image_from_fs : "",
      template_image_id: this.props.template_image_id ? this.props.template_image_id : -1,
      draws: [],
      isDrawing: false,
      mode: 'brush',
      lineWidth: 4,
      objColor: "#ff0000",
      text: 'Escreva aqui',
      anchorEl: null,
      openMenu: false,
      stageWidth: 100,
    }; 
  }
  
  stageRef = React.createRef();
  
  
  componentDidMount() {
    this.checkSize();
    // here we should add listener for "container" resize, for simplicity I will just listen window resize
    window.addEventListener("resize", this.checkSize);
    
    if(this.state.background_image_id > 0)
      this.getFileFromFileServer(this.state.background_image_id);
  } 
  
  componentWillUnmount() {
    window.removeEventListener("resize", this.checkSize);
  }

  checkSize = () => {
    var container = document.querySelector('#stage-parent');
    if(container){
      const width = container.offsetWidth;
      this.setState({stageWidth: width});
    }
  };
  

  getFileFromFileServer = (id) => {
    this.props.api
      .get('/FileServer/file/' + id, {responseType: 'blob'})
      .then((r) => {
        if( r.type !== "application/json" ){  
          const url = URL.createObjectURL(r);
        
          // in case you don't need the blob anymore, blob can be garbage collected
          //img.onload = e => URL.revokeObjectURL(url);
        
          this.setState({background_image_from_url: url});
        }
        else{
          try{  
          const outurl = URL.createObjectURL(r);
          fetch(outurl).then(res => {
            res.text().then(txt => {
              var dic = JSON.parse(txt);
              var msg = dic.error
              if(dic.coldstorage)
                msg = msg + ". Arquivo dispónível somente no coldstorage."
              this.props.alert(msg);
            });  
          });
          }catch(err){
            console.log(err);
          }
        }
      })
      .catch((e) => {
        console.log(e);
      });       
  }
    
  handleSave = () => {
    this.props.dialogClose();        
    
    const uri = this.stageRef.current.toDataURL();  //Returns the base64 image 
    const blob = this.b64toBlob(uri.slice("data:image/png;base64,".length), "image/png");
    
    //var blobUrl = URL.createObjectURL(blob);
    //window.open(blobUrl);
    
    this.sendFile(blob);
  }
  
  b64toBlob = (b64Data, contentType='', sliceSize=512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    
    const blob = new Blob(byteArrays, {type: contentType});
    return blob;
  }
  
  sendFile = (file) => {
    var chunkSize = 3 * 1024 * 1024;
    const totalChunks = Math.ceil(file.size / chunkSize);
    let chunkNumber = 0;
 
    const uploadChunk = async (chunk, chunkNumber, totalChunks) => {
      const formData = new FormData();
      formData.append('chunk', chunk);
      formData.append('chunkNumber', chunkNumber);
      formData.append('totalChunks', totalChunks);
      formData.append('fileName', 'Planning.png');
      formData.append('type', file.type);
      formData.append('registerIntoDB', true);
  
      this.props.api.post('/FileServer/upload', formData, { 
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then((response) => {
        if (response.status === 200) {
          //console.log(`Chunk ${chunkNumber + 1} de ${totalChunks} enviado com sucesso`);
          chunkNumber++;
          if (chunkNumber < totalChunks) {
            const start = chunkNumber * chunkSize;
            const end = Math.min(file.size, start + chunkSize);
            const nextChunk = file.slice(start, end);
            uploadChunk(nextChunk, chunkNumber, totalChunks);
          } else {
            //console.log('Upload completo');
            //console.log("db_record",response.db_record);
            this.props.dialogSave(false,false,false,true,false,response.db_record.id,null);
          }
        }
        else {
          //console.log('Erro no upload do chunk:', response.statusText);
        }
      })
      .catch((error) => {
        console.log('Erro:', error.message);     
      })
    };    

 
    const firstChunk = file.slice(0, chunkSize);
    uploadChunk(firstChunk, chunkNumber, totalChunks);     
  };
  
  
   
  handleMouseDown = (e) => {
    const p = this.stageRef.current.getPointerPosition();//e.evt
    const offsetX = parseInt(p.x);
    const offsetY = parseInt(p.y);
    
    
    var draws = this.state.draws;
    // add point twice, so we have some drawings even on a simple click
    draws.push({tool: this.state.mode, color: this.state.objColor, width: this.state.lineWidth, points: [offsetX, offsetY, offsetX, offsetY], text: this.state.text});
    this.setState({isDrawing: true, draws: draws});
  }
  


  handleMouseUp = (e) => {
    if (this.state.isDrawing){
      if(this.state.draws[this.state.draws.length - 1].tool === 'text'){

      }
      this.setState({isDrawing: false});
    }
  }
  
  
  handleMouseMove = (e) => {
    if (!this.state.isDrawing)
      return;
    
    const p = this.stageRef.current.getPointerPosition();//e.evt
    const offsetX = parseInt(p.x);
    const offsetY = parseInt(p.y);

    if(this.state.isDrawing) {
      if( (this.state.draws[this.state.draws.length - 1].tool === 'brush') || (this.state.draws[this.state.draws.length - 1].tool === 'eraser')){
        let lastLine = this.state.draws[this.state.draws.length - 1]
      
        lastLine.points = lastLine.points.concat([offsetX, offsetY]);
        this.state.draws.splice(this.state.draws.length - 1, 1, lastLine);
        this.setState({draws: this.state.draws.concat()});
      }
    }
  }
  
   
   handleUndo = () => {
    if(this.state.draws.length > 0){
      var draws = this.state.draws;
      draws.pop()
      this.setState({draws: draws});
    }
  } 
    
  handleColorPicker = (event) => {
    this.setState({ anchorEl: event.currentTarget, openMenu: Boolean(event.currentTarget) });
  }
  
  handleColorPickerClose = () => {
    this.setState({ anchorEl: null, openMenu: false });
  };
  
  handleImage = (files) => { 
    this.setState({background_image_id: -1, background_image_from_fs: files[0]})
  } 
  
  handleClearImage = () => { 
    this.getFileFromFileServer(this.state.template_image_id);
  }
  
  render() {
    return (
      <D className="col e aF pa">
        <DialogTitle>Plano de Tratamento</DialogTitle>
        <DialogContent style={{ minWidth: "25vw" }}>

      <Stack direction="row" spacing={3} >
        <Tooltip title="Lápis" arrow style={{padding: '0rem', margin: '0rem'}}>
          <IconButton onClick={() => this.setState({mode: 'brush'})} size="small">
            <DriveFileRenameOutline />
          </IconButton>
        </Tooltip> 
        <D style={{marginLeft: 12}} />
        <Tooltip title="Borracha" arrow style={{padding: '0rem', margin: '0rem'}}>
          <IconButton onClick={() => this.setState({mode: 'eraser'})} size="small">
            <CleaningServices />
          </IconButton>
        </Tooltip>
        <D style={{marginLeft: 12}} />
        <Tooltip title="Texto" arrow style={{padding: '0rem', margin: '0rem'}}>
          <IconButton onClick={() => this.setState({mode: 'text'})} size="small">
            <Abc />
          </IconButton>
        </Tooltip>
        <TextField
          size="small"
          value={this.state.text}
          onChange={(e) => this.setState({text: e.target.value})}
          style={{marginLeft: 12}}
        />
        <D style={{marginLeft: 12}} />
        <div style={{position: 'relative', padding: '0rem', margin: '0rem'}}>
          <div 
            style={{width: '28px', height: '28px', borderRadius: '8px', border: '3px solid #fff', boxShadow: '0 0 0 1px rgba(0, 0, 0, 0.1), inset 0 0 0 1px rgba(0, 0, 0, 0.1)', cursor: 'pointer', backgroundColor: this.state.objColor}}
            id="basic-button"
            aria-controls={this.state.openMenu ? 'basic-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={this.state.openMenu ? 'true' : undefined}
            onClick={this.handleColorPicker}
          />
          <Menu
            id="basic-menu"
            anchorEl={this.state.anchorEl}
            open={this.state.openMenu}
            onClose={this.handleColorPickerClose}
            MenuListProps={{
              'aria-labelledby': 'basic-button',
            }}
          >
          <HexColorPicker color={this.state.objColor} style={{padding: '1rem'}} onChange={(e) => this.setState({objColor: e})}/>            
          </Menu>
        </div>
        <D style={{marginLeft: 12}} />
        <Tooltip title="Limpar Imagem de Fundo" arrow style={{padding: '0rem', margin: '0rem'}}>
          <IconButton onClick={() => this.handleClearImage()} size="small">
            <ImageNotSupported />
          </IconButton>
        </Tooltip>
        <D style={{marginLeft: 12}} />
        <Tooltip title="Nova Imagem de Fundo" arrow style={{padding: '0rem', margin: '0rem'}}>
          <IconButton size="small" component="label">
            <Photo />
            <input
              styles={{display:"none"}}
              type="file"
              hidden
              accept={C.acceptableImagesTypes}
              onChange={(e) => this.handleImage(e.target.files)}
              id="bg-upload-input"
            />
          </IconButton>
        </Tooltip>
        <D style={{marginLeft: 12}} />
        <Tooltip title="Defazer" arrow style={{padding: '0rem', margin: '0rem'}}>
          <IconButton onClick={() => this.handleUndo()} size="small">
            <Undo />
          </IconButton>
        </Tooltip>
      </Stack>
      <D h="1rem" />
                  
      <D id="stage-parent" h={this.state.stageWidth}>
      <Stage width={this.state.stageWidth} height={this.state.stageWidth}
        onMouseDown={this.handleMouseDown}
        onTouchStart={this.handleMouseDown}
        onMouseUp={this.handleMouseUp}
        onTouchEnd={this.handleMouseUp}
        onMouseMove={this.handleMouseMove}
        onTouchMove={this.handleMouseMove}
        style={{border: '1px solid silver'}}
        ref={this.stageRef}
      >
        <Layer>
          {(this.state.background_image_id !== -1) &&
            <URLImage src={this.state.background_image_from_url} width={this.state.stageWidth} height={this.state.stageWidth} />
          }
          {(this.state.background_image_from_fs !== "") &&
            <FSImage src={this.state.background_image_from_fs} width={this.state.stageWidth} height={this.state.stageWidth} />
          }
          {this.state.draws.map((obj, i) => {
            if((obj.tool === 'eraser') || (obj.tool === 'brush'))
              return <Line 
                key={i} 
                points={obj.points} 
                stroke={obj.color}
                strokeWidth={obj.tool === "eraser" ? parseInt(obj.width*1.5) : obj.width} 
                globalCompositeOperation={obj.tool === "eraser" ? "destination-out" : "source-over"}
                lineCap='round'
                lineJoin='round'
              />
            if(obj.tool === 'text')
              return <Text
                key={i} 
                x={obj.points[0]}
                y={obj.points[1]}
                text={obj.text}
                fontSize={30}
                fontFamily={'Calibri'}
                fill={obj.color}
              />
          })}
        </Layer>
      </Stage>    
      </D>

              
        
        </DialogContent>
        <DialogActions>
          {this.state.read_only && 
          <Button variant="outlined" color="primary" onClick={this.props.dialogClose}>Fechar</Button>
          }
          {!this.state.read_only && <>
          <Button variant="outlined" color="primary" onClick={this.props.dialogClose}>Cancelar</Button>
          <Button variant="outlined" color="primary" onClick={this.handleSave}>Salvar</Button>
          </>}
        </DialogActions>
      </D>
    );
  }
}








class URLImage extends React.Component {
  state = {
    image: null,
  };
  componentDidMount() {
    this.loadImage();
  }
  componentDidUpdate(oldProps) {
    if (oldProps.src !== this.props.src) {
      this.loadImage();
    }
  }
  componentWillUnmount() {
    this.image.removeEventListener('load', this.handleLoad);
  }
  loadImage() {
    // save to "this" to remove "load" handler on unmount
    this.image = new window.Image();
    this.image.src = this.props.src;
    this.image.addEventListener('load', this.handleLoad);
  }
  handleLoad = () => {
    // after setState react-konva will update canvas and redraw the layer
    // because "image" property is changed
    this.setState({
      image: this.image,
    });
    // if you keep same image object during source updates
    // you will have to update layer manually:
    // this.imageNode.getLayer().batchDraw();
  };
  render() {
    return (
      <Image
        x={0}
        y={0}
        width={this.props.width}
        height={this.props.height}
        image={this.state.image}
      />
    );
  }
}






class FSImage extends React.Component {
  state = {
    image: null,
  };
  componentDidMount() {
    this.loadImage();
  }
  componentDidUpdate(oldProps) {
    if (oldProps.src !== this.props.src) {
      this.loadImage();
    }
  }
  componentWillUnmount() {
    this.image.removeEventListener('load', this.handleLoad);
  }
  loadImage() {
    var URL = window.webkitURL || window.URL;
    var url = URL.createObjectURL(this.props.src);
    
    // save to "this" to remove "load" handler on unmount
    this.image = new window.Image();
    this.image.src = url;
    this.image.addEventListener('load', this.handleLoad);
  }
  handleLoad = () => {
    // after setState react-konva will update canvas and redraw the layer
    // because "image" property is changed
    this.setState({
      image: this.image,
    });
    // if you keep same image object during source updates
    // you will have to update layer manually:
    // this.imageNode.getLayer().batchDraw();
  };
  render() {
    return (
      <Image
        x={0}
        y={0}
        width={this.props.width}
        height={this.props.height}
        image={this.state.image}
      />
    );
  }
}









